export default __webpack_public_path__ + "static/Activity-4x3-S_Run-31d09cee091fbc8b5c82b1f1a168db99.png";